const keys = {
  profile: {
    back: 'Back',
    title: 'My Account',
    subtitle:
      'Manage your profile here. Please not that changing your email will also update the email you use to log in.',
    fields: {
      name: 'Name',
      email: 'Email',
      phoneNumber: 'Phone Number',
    },
    editEmailDialog: {
      title: 'Edit email',
      fields: {
        email: {
          label: 'What is your new email?',
          placeholder: 'Email',
        },
        passcode: {
          label: 'Enter the 6-digit code we just sent to {{0}}:',
          placeholder: 'Passcode',
          invalid: 'Invalid passcode',
        },
      },
      conflict: {
        content:
          'Oops, there is already an account associated with this email. Please use a different email or <0>contact support</0>.',
        ok: 'Ok',
      },
    },
    undoEdit: 'Undo',
    confirmEdit: 'Update',
    editTooltip: 'Modify',
  },
};

export default keys;

export type TranslationKeys = typeof keys;
